export default __webpack_public_path__ + "static/media/logoGlearning.922957c1.svg";